import React, { useEffect, useState, useCallback } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper-bundle.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useParams } from "react-router-dom";
import { getFetcher } from "../../../api/fetchers";
import { endpoints } from "../../../api/endpoints";
import { useUser } from "../../context/UserContext";
import Spinner from "../../components/spinner/Spinner.tsx";
import ProductCart from "../ProductCart.tsx";
import { useLanguage } from "../../context/LanguageContext.tsx";

interface B2B {
  id: string;
  name: string;
  ratio: number;
}

const SimilarProducts: React.FC = () => {
  // const navigate = useNavigate();
  const { t } = useLanguage();
  const { productId } = useParams<{ productId: string }>();
  const { user } = useUser();
  const [products, setProducts] = useState<any[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [userBusinessPackage, setUserBusinessPackage] = useState<B2B>();

  const fetchSimilarProducts = useCallback(async () => {
    try {
      const response = await getFetcher(
        endpoints.products.getSimilarProducts.replace("{id}", productId || "")
      );
      if (response.result) {
        const productsWithImagesParsed = response.products.map(
          (product: any) => ({
            ...product,
            images: product.images,
          })
        );
        setProducts(productsWithImagesParsed);
      } else {
        toast.error(response.message);
      }
    } catch (error) {
      console.error("Error fetching similar products:", error);
      toast.error("Error");
    }
  }, [productId]);

  const fetchBusinessPackageData = async () => {
    if (user) {
      try {
        const businessPackage = await getFetcher(
          endpoints.user.getBusinessPackageById.replace(
            "{id}",
            user.businessPackageId
          )
        );
        if (businessPackage.result) {
          setUserBusinessPackage(businessPackage.businessPackage);
        }
      } catch (error) {
        console.error("Error fetching business package:", error);
      } finally {
        console.log("first");
      }
    } else {
      console.log("err");
    }
  };

  useEffect(() => {
    fetchBusinessPackageData();
  }, [user]);


  useEffect(() => {
    fetchBusinessPackageData();
    if (user && productId) {
      setLoading(true);
      Promise.all([fetchSimilarProducts()]);
    } else {
      setLoading(false);
    }
  }, [user, productId, fetchSimilarProducts]);

  if (loading) {
    return (
      <div className="spinner-container">
        <Spinner />
      </div>
    );
  }

  return products?.length > 0 ? (
    <>
      <div className=" w-11/12 mx-auto mt-10 overflow-hidden">
        <h2 className=" font-poppins text-2xl text-primary-color font-semibold">
          {t("productDetail", "similarProduct")}
        </h2>
      </div>
      <div className="border-b-2 border-color-gray py-6 w-11/12 mx-auto -mt-10"></div>
      <main className="w-full px-12 pt-3 pb-12">
        <Swiper
          spaceBetween={20}
          className="customSwiperNewProducts"
          slidesPerView={1}
          breakpoints={{
            320: {
              slidesPerView: 1,
              spaceBetween: 8,
            },
            580: {
              slidesPerView: 2,
              spaceBetween: 8,
            },
            792: {
              slidesPerView: 4,
              spaceBetween: 10,
            },
            1024: {
              slidesPerView: 5,
              spaceBetween: 12,
            },
            1060: {
              slidesPerView: 2,
              spaceBetween: 15,
            },
            1100: {
              slidesPerView: 3,
              spaceBetween: 15,
            },
            1240: {
              slidesPerView: 4,
              spaceBetween: 15,
            },
            1280: {
              slidesPerView: 4,
              spaceBetween: 15,
            },
            1600: {
              slidesPerView: 6,
              spaceBetween: 20,
            },
            1900: {
              slidesPerView: 7,
              spaceBetween: 20,
            },
          }}
        >
          {products.map((product) => (
            <SwiperSlide key={product.id} className=" p-10">
              <ProductCart
                product={product}
                userBusinessPackage={userBusinessPackage}
              />
            </SwiperSlide>
          ))}
        </Swiper>
      </main>
    </>
  ) : null;
};

export default SimilarProducts;
